"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleTransactionFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.saleTransactionFactory = Factory.Sync.makeFactory({
    id: Mocks.clare.txnId,
    action: null,
    amount: Mocks.clare.amountTen,
    amount_refunded: Mocks.clare.amountZero,
    authorization: 'auth_string',
    avs_result: null,
    batch_date: Mocks.dates.date2000,
    can_be_disputed: true,
    can_be_refunded: true,
    created_at: Mocks.dates.date2000,
    currency: Mocks.clare.usd,
    currency_symbol: Mocks.clare.usdSymbol,
    customer_ip: '0.0.0.0',
    cvv_result: null,
    description: 'desc',
    fraud_review: null,
    gateway_error: null,
    message: '',
    merchant_account_id: 2,
    original_trans_id: 3,
    payment_method_id: 4,
    properties: {},
    non_refundable_reason: 'generic',
    response_params: {},
    sale_description: '',
    sale_id: Mocks.clare.saleId,
    sale_number: Mocks.clare.saleNumber,
    sale_type: Mocks.clare.orderType,
    recipient: Mocks.persona.full_name,
    status: 'approved',
    success: true,
    tender: Mocks.clare.tenderCard,
    tender_display: Mocks.clare.cardLabel,
    trxtype: 'S',
    trxtype_display: 'Sale',
    user_id: Mocks.persona.id,
    invoice_group_id: null,
    payment_identifier: null
});
